import { useCallback } from "react";
import { useABACHandler } from "../../../utils/hooks/useABACHandler";
import { Ability } from "@casl/ability";
import { useLocation } from "react-router-dom";
import { AuthenticationResponse } from "certiblok-api-manager";

export function useLoginRedirect(params?: { isSyncLogin?: boolean }) {
	const { loadABACPermissionAndNavigateTo } = useABACHandler();

	const location = useLocation();

	const from = (location.state as any)?.from?.pathname || "/";

	return useCallback(
		(res: AuthenticationResponse) => {
			//@ts-expect-error
			const loginAbility = new Ability(res.abilityRules);

			const needRecover = loginAbility.can("manage", "Recovery");
			if (needRecover) {
				loadABACPermissionAndNavigateTo(res, `/recover-profile`);
				return;
			}
			const needTwoFA = loginAbility.can("manage", "2FA");
			if (needTwoFA) {
				loadABACPermissionAndNavigateTo(res, `/login/two-fa` + (params?.isSyncLogin ? "?platform=sync" : ""));
			} else {
				loadABACPermissionAndNavigateTo(res, from);
			}
		},
		[loadABACPermissionAndNavigateTo]
	);
}
